module.exports = "/_next/static/images/phone-note-1-9dad69d863ceb7f814a66561c18948b6.png.webp";